import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseSectionService } from '../../services/course-section.service'; // adjust path if needed
import { MatDialog } from '@angular/material/dialog';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { ToastService } from 'src/app/core/toast.service';
import { LoginService } from 'src/app/core/services/login.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { formatDate } from '@angular/common';
import { Overlay } from '@angular/cdk/overlay';
import { CourseDetailsPreviewComponent } from '../course-details-preview/course-details-preview.component';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-course-listing',
  templateUrl: './course-listing.component.html',
  styleUrls: ['./course-listing.component.scss']
})
export class CourseListingComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport) companyViewport!: CdkVirtualScrollViewport;
receivedId: any;

  currentTab = 'ALL';
  searchTerm: string = '';
  loginDetails: any;
  companySearchText: string = "";
  limit = 10;
  offset = 0;
  loading = false;
  endOfData = false;
  isLoadingCompanies = false;
  hasMoreCompanies = true;
  showCompanyDropdown = false;
  openFilter = false;
  filterType = '';
  filterCompany = '';
  tabCounts: any = {};
  lastSearchTerm = '';
  getCourseType: any[] = [];
  allCoursesData: any[] = [];
  getCourseCompany: any[] = [];
  filteredCourseTypes: any[] = [];
  filteredCourseCompanies: any[] = [];
  private searchSubject = new Subject<string>();
  private typeSearch$ = new Subject<string>();
  private companySearch$ = new Subject<string>();
  typeLimit = 10;
  typeOffset = 0;
  companyLimit = 10;
  companyOffset: number = 0;
  private destroy$ = new Subject<void>();
  private forceRefreshTab = false;
  private lastTypeSearch = '';
  private lastCompanySearch = '';

  hasMoreTypes = true;
  isLoadingTypes = false;
  filterMonth: string = "";
  selectedMonth: Date | null = null;
  dataLoader = false;

  constructor(private commonService:CommonServicesForAllModules,private overlay: Overlay, private router: Router, 
    private CourseSectionService: CourseSectionService, 
     private route: ActivatedRoute, 
    private dialog: MatDialog, private toast: ToastService, private loginService: LoginService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {


      this.route.queryParams.subscribe(params => {
    
     this.receivedId = params['id'];
       if (this.receivedId) {
          // ✅ Activate the PENDING tab
      this.currentTab = 'PENDING';

      // Optionally load data for the PENDING tab immediately
      this.forceRefreshTab = true;
      this.offset = 0;
      this.allCoursesData = [];
      this.loadMoreCourses(true);
  }
 
      });



    this.loginDetails = this.loginService.getLoginData();
    this.loadTabCounts();
    this.spinner.show();
    this.loadMoreCourses(true);
    this.searchSubject
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe((term) => {
        this.handleDebouncedSearch(term);
      });
    this.typeSearch$.pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe((val) => this.getCourseTypes(true, val));

    this.companySearch$.pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe((val) => this.getCompanyNames(true, val));
  }


  onTabChange(tab: string): void {
    if (this.currentTab === tab && !this.forceRefreshTab) {
      return;
    }
    this.dataLoader = true;
    this.currentTab = tab;
    this.forceRefreshTab = false;
    this.offset = 0;
    this.allCoursesData = [];
    this.endOfData = false;
    this.loadMoreCourses();
  }


  getStatusForTab(tab: string): { status?: string; active_status?: string } {
    switch (tab) {
      case 'ACTIVE':
        return { status: 'APPROVE', active_status: 'ACTIVE' };
      case 'INACTIVE':
        return { status: 'APPROVE', active_status: 'INACTIVE' };
      // case 'APPROVE':
      //   return { status: 'APPROVE' };
      case 'REJECTED':
        return { status: 'REJECT' };
      case 'DRAFT':
        return { status: 'DRAFT' };
      case 'PENDING':
        return { status: 'PENDING' };
      case 'EXPIRED':
        return { status: 'EXPIRED' };
      default:
        return {};
    }
  }


  onSearchChange(): void {
    const trimmed = this.searchTerm?.trim() || '';
    if (trimmed === this.lastSearchTerm) return;
    this.lastSearchTerm = trimmed;
    this.searchSubject.next(trimmed);
  }
  onSearchClick(): void {
    const trimmed = this.searchTerm?.trim() || '';
    if (!trimmed) return;
    if (trimmed === this.lastSearchTerm) return;
    this.lastSearchTerm = trimmed;
    this.handleDebouncedSearch(trimmed);
  }


  handleDebouncedSearch(term: string): void {
    this.offset = 0;
    this.allCoursesData = [];
    this.endOfData = false;
     this.dataLoader = true;
    this.loadMoreCourses();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadTabCounts(): void {
    this.CourseSectionService.getCoursesTabCounts().subscribe((res: any) => {
      this.tabCounts = {
        ALL: res?.data?.all?.aggregate?.count || 0,
        DRAFT: res?.data?.draft?.aggregate?.count || 0,
        PENDING: res?.data?.pending?.aggregate?.count || 0,
        ACTIVE: res?.data?.active?.aggregate?.count || 0,
        INACTIVE: res?.data?.inactive?.aggregate?.count || 0,
        EXPIRED: res?.data?.expired?.aggregate?.count || 0,
        REJECTED: res?.data?.rejected?.aggregate?.count || 0,
      };
    });
  }


  loadMoreCourses(isInitialLoad = false): void {
    if (this.loading || this.endOfData) return;
    this.loading = true;
    const { status, active_status } = this.getStatusForTab(this.currentTab);
    this.CourseSectionService.getAllCourses(
      this.limit,
      this.offset,
      status,
      active_status,
      this.searchTerm,
      this.filterType,
      this.filterCompany,
      this.filterMonth
    ).subscribe({
      next: (res: any) => {
        const newCourses = res?.data?.courses || [];
        if (newCourses.length < this.limit) {
          this.endOfData = true;
        }
        this.allCoursesData = [...this.allCoursesData, ...newCourses];        

        this.offset += this.limit;
        this.loading = false;
        this.dataLoader = false;
        if (isInitialLoad) {
          this.spinner.hide();
        }
      },
      error: () => {
        this.loading = false;
        this.dataLoader = false;
        //  also hide spinner in case of error
        if (isInitialLoad) {
          this.spinner.hide();
        }
      }
    });
  }

  refreshCurrentTabData(): void {
    this.offset = 0;
    this.endOfData = false;
    this.allCoursesData = [];
    this.loadMoreCourses();
  }

  isAdmin(): boolean {
    return this.loginDetails?.type === 'ADMIN';
  }
  canEdit(createdById: number): boolean {
    // Admin/Supplier can only edit their own course
    return createdById === this.loginDetails?.id;
  }
  creator(createdById: number): boolean {
    // Admin/Supplier can only delete their own course
    return createdById === this.loginDetails?.id;
  }

  handleCreateJobClick(): void {
    this.router.navigate(['/profile/course-post']);
  }
  editCourse(course: any): void {
    this.router.navigate(['/profile/course-post/edit', course.id]);
  }
  deleteCourse(courseId: string): void {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      data: {
        item: courseId,
        name: "Course"
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response === 'yes') {
        this.commonService.DeleteById(Tables.Courses, courseId).then(() => {
          this.toast.openSnackBar('Course deleted successfully');
          this.forceRefreshTab = true;
          this.refreshCurrentTabData();
          this.loadTabCounts();
        });
      }
    });
  }


  async updateCourseStatus(status: string, courseId: string): Promise<void> {
    try {
      await this.commonService.UpdateData(Tables.Courses, courseId, {
        active_status: status,
      });

      this.toast.openSnackBar(`Course marked as ${status}`);
      this.forceRefreshTab = true;
      this.refreshCurrentTabData();
      this.loadTabCounts();
    } catch (error) {
      console.error('Failed to update course status:', error);
      this.toast.openSnackBar('Unable to update course status');
    }
  }

  async updateCourseApprovalStatus(status: 'APPROVE' | 'REJECT', courseId: string): Promise<void> {
    try {
      await this.commonService.UpdateData(Tables.Courses, courseId, {
        status: status,
      });

      const msg = status === 'APPROVE' ? 'Approved' : 'Rejected';
      this.toast.openSnackBar(`Course ${msg} successfully`);
      this.forceRefreshTab = true;
      this.refreshCurrentTabData();
      this.loadTabCounts();
      
    // ✅ After approval, remove 'id' from query params
 
      this.router.navigate([], {
        queryParams: { id: null },
        queryParamsHandling: 'merge', // keep other params intact
      });
     
    } catch (error) {
      console.error(`Failed to ${status.toLowerCase()} course:`, error);
      this.toast.openSnackBar(`Unable to ${status.toLowerCase()} course`);
    }
  }

  viewCourse(courseId: string | number): void {

    this.dialog.open(CourseDetailsPreviewComponent, {
      width: '60%',
      panelClass: ['custom-modal'],
      data: { id: courseId } // send only the id
    });
  }




  trackByCourseId(index: number, CourseId: any): string {
    return CourseId.id;
  }



  toggleFilter(): void {
    this.openFilter = !this.openFilter;

    if (this.openFilter) {
      if (!this.getCourseType.length) {
        this.getCourseTypes();
      }
      if (!this.getCourseCompany.length) {
        this.getCompanyNames();
      }
    }
  }

  hideDropdown(type: string, event?: FocusEvent) {
    const related = event?.relatedTarget as HTMLElement;
    if (type === 'company' && related?.closest('.dropdown-item')) {
      return; // don’t hide if clicking inside dropdown
    }
    setTimeout(() => this.showCompanyDropdown = false, 150);
  }





  getCourseTypes(reset = false, search: string = ''): void {
    if (this.isLoadingTypes || !this.hasMoreTypes) return;
    this.isLoadingTypes = true;

    if (reset) {
      this.typeOffset = 0;
      this.getCourseType = [];
      this.filteredCourseTypes = [];
      this.hasMoreTypes = true;
    }

    this.CourseSectionService.getCourseType(this.typeLimit, this.typeOffset, search)
      .subscribe((res: any) => {
        if (res && res.length > 0) {
          this.getCourseType = [...this.getCourseType, ...res];
          this.filteredCourseTypes = [...this.getCourseType];
          this.typeOffset += this.typeLimit;
        } else {
          this.hasMoreTypes = false;
        }
        this.isLoadingTypes = false;
      });
  }



  getCompanyNames(reset = false, search: string = ''): void {
    if (this.isLoadingCompanies) return;

    // Process reset FIRST so we can refresh even if hasMoreCompanies was false
    if (reset) {
      this.companyOffset = 0;
      this.getCourseCompany = [];
      this.filteredCourseCompanies = [];
      this.hasMoreCompanies = true;
    }

    // Now guard "no more data" after a possible reset
    if (!this.hasMoreCompanies) return;

    this.isLoadingCompanies = true;

    this.CourseSectionService.getCompanyName(this.companyLimit, this.companyOffset, search)
      .subscribe({
        next: (res: any) => {
          const list = Array.isArray(res) ? res : [];
          if (list.length > 0) {
            this.getCourseCompany = [...this.getCourseCompany, ...list];
            this.filteredCourseCompanies = [...this.getCourseCompany];
            this.companyOffset += this.companyLimit;
          } else {
            this.hasMoreCompanies = false;
          }
          this.isLoadingCompanies = false;
        },
        error: () => {
          this.isLoadingCompanies = false;
        }
      });
  }

  onCompanyScrolled(): void {
    if (!this.companyViewport || this.isLoadingCompanies) return;

    const totalHeight = this.companyViewport.getDataLength() * 40;
    const viewPortHeight = this.companyViewport.getViewportSize();
    const scrollOffset = this.companyViewport.measureScrollOffset();

    // If near bottom (within 100px threshold)
    if (scrollOffset + viewPortHeight >= totalHeight - 100) {
      this.getCompanyNames(false, this.companySearchText);
    }
  }


  onTypeInput(value: string): void {
    const trimmed = (value || '').trim();
    this.filterType = trimmed;
    this.typeSearch$.next(trimmed);
  }

  onCompanyInput(value: string): void {
    const trimmed = (value || '').trim();
    this.filterCompany = trimmed;
    this.companySearch$.next(trimmed);
  }

  onTypeSelected(selectedName: string): void {
    this.filterType = selectedName;
    this.filteredCourseTypes = [...this.getCourseType];
    this.lastTypeSearch = selectedName.trim();
    this.dataLoader = true;
    this.refreshCurrentTabData();
  }

  onCompanySelected(selectedName: string): void {
    this.filterCompany = selectedName;
    this.filteredCourseCompanies = [...this.getCourseCompany];
    this.lastCompanySearch = selectedName.trim();
    this.dataLoader = true;
    this.refreshCurrentTabData();
  }





  // called when user picks a date
  chosenDateHandler(date: Date | null) {
    if (!date) {
      // User cleared input → reset everything
      this.selectedMonth = null;
      this.filterMonth = "";

      this.offset = 0;
      this.endOfData = false;
      this.dataLoader = true;
      this.allCoursesData = [];
      this.loadMoreCourses(); // reload all data without filter
      return;
    }

    //  When user selects a date
    this.selectedMonth = date;
    this.filterMonth = formatDate(this.selectedMonth, 'yyyy-MM-dd', 'en-US');

    this.offset = 0;
    this.endOfData = false;
    this.dataLoader = true;
    this.allCoursesData = [];
    this.loadMoreCourses();
  }



  clearAllFilters(): void {
    const hadFilters =
      (this.filterType && this.filterType.trim() !== '') ||
      (this.filterCompany && this.filterCompany.trim() !== '') ||
      (this.filterMonth && this.filterMonth.trim() !== '');

    this.filterType = '';
    this.filterCompany = '';
    this.filterMonth = '';
    this.selectedMonth = null;

    this.filteredCourseTypes = [...this.getCourseType];
    this.filteredCourseCompanies = [...this.getCourseCompany];
    this.lastTypeSearch = '';
    this.lastCompanySearch = '';

    if (hadFilters) {
      this.dataLoader = true;
      this.refreshCurrentTabData();
    }
  }

  prsentersConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    speed: 1000,
    spaceBetween: 10,
    effect: 'slide', // Swiper 6 supports 'slide', 'fade', 'cube', etc.
  };


}
